import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "results", "form" ]

  //connect() {
  //  console.log("Connected!")
  //}

  search() {
    Rails.fire(this.formTarget, "submit")
  }

  handleResults() {
    const [data, status, xhr] = event.detail
    this.resultsTarget.innerHTML = xhr.response

    const links_select_product = document.querySelectorAll(
      "a#select_product"
    );
    links_select_product.forEach((element) => {
      element.addEventListener("click", (event) => {
          event.preventDefault();
          document.querySelector('#search').value = event.target.getAttribute('data-product-name')
          Rails.fire(document.querySelector('#search'), 'input');
      })
    });


    const element = document.querySelector("#change-inventory");
    if (element != null) {
      element.addEventListener("ajax:success", (event) => {
        const [data, status, xhr] = event.detail

        document.querySelector("#product_inventory_status").innerHTML = xhr.response;
        //alert("Changed inventory");    
      });
      element.addEventListener("ajax:error", (event) => {
        const [_data, _status, xhr] = event.detail;
        alert(xhr.responseText)
      });
    }

  }
}
